// extracted by mini-css-extract-plugin
export default {"container":"qB-z","vocBtn":"rB-z","disabled":"sB-z"};